import styled from 'styled-components';

export const Spinner = styled.div`
    padding: 20% 50% 0 50%;
`;
